import { isRole } from "./roles";
import { expandRoles } from "./expand";

export interface WidgetGateInput {
  adminOnly?: boolean;
  requiredRoles?: readonly string[];
}

export function widgetGate(
  widget: WidgetGateInput,
  userRoles: readonly string[],
): boolean {
  const expanded = expandRoles(userRoles);
  if (widget.adminOnly) return expanded.has("admin");
  if (!widget.requiredRoles?.length) return true;
  return widget.requiredRoles.some((r) => isRole(r) && expanded.has(r));
}
